/* eslint-disable @typescript-eslint/no-var-requires */
import React from "react";
import { oneLink } from "../../shared/oneLink";
import Headline from "../../components/Headline";
import { MainLayout } from "../../components/Layout";
import * as aa from "../../generated/UserAPIAgent";
import LinkButton from "../../components/LinkButton";
import AppStoreLinks from "../../components/AppStoreLinks";
import Modal from "../../components/Modal";
import { URL_PATHS } from "../../routes";
import { IAPPaymentMethod } from "../../generated/lib-domain/iap";
import dayjs from "dayjs";
import "./styles.scss";

interface ContractPaidMemberProps {
    paymentStatus: aa.PaymentStatusObj;
    freeMember: boolean;
    paidMember: boolean;
    createdMember: boolean;
    paidStopMember: boolean;
    isShowModal: boolean;
    onClickWithdrawalApply: () => void;
    onClickModalClose: () => void;
}

const ContractPaidMember = (props: ContractPaidMemberProps): JSX.Element => (
    <MainLayout>
        <Headline>契約確認・変更</Headline>
        <div className="contract-paid-status">
            <ViewCreatedMember createdMember={props.createdMember} />
            <ViewFreeMember freeMember={props.freeMember} />
            <ViewPaidMember
                paidMember={props.paidMember}
                paymentStatus={props.paymentStatus}
            />
            <ViewPaidStopMember
                paidStopMember={props.paidStopMember}
                paymentStatus={props.paymentStatus}
            />
        </div>
        <div className="withdrawal-link" onClick={props.onClickWithdrawalApply}>
            退会申請 &gt;
        </div>
        <Modal
            isShow={props.isShowModal}
            onClickModalClose={props.onClickModalClose}
        >
            <div className="paid-modal-contents">
                有料会員プランを更新予定のあいだは退会できません。先に
                <b className="accept">有料会員プランの停止</b>を行ってください。
            </div>
        </Modal>
    </MainLayout>
);

interface ViewCreatedMemberProps {
    createdMember: boolean;
}

const ViewCreatedMember = (props: ViewCreatedMemberProps) =>
    props.createdMember && (
        <>
            <h3>入会審査が完了していません</h3>
            <p>
                アプリをダウンロードしてパートナーエージェントAppをご利用ください。
            </p>
            <AppStoreLinks linkTo={oneLink} />
        </>
    );

interface ViewFreeMemberProps {
    freeMember: boolean;
}

const ViewFreeMember = (props: ViewFreeMemberProps) =>
    props.freeMember && (
        <>
            <h3>有料会員プラン</h3>
            <p>
                有料会員プランになると、マッチングしたお相手とのコンタクトやメッセージのやりとりが可能になります。
            </p>
            <LinkButton to={URL_PATHS.paymentPlan()} color="primary">
                有料会員プランを契約する
            </LinkButton>
        </>
    );

interface ViewPaidMemberProps {
    paidMember: boolean;
    paymentStatus: aa.PaymentStatusObj;
}

const ViewPaidMember = (props: ViewPaidMemberProps) =>
    props.paidMember && (
        <>
            <div className="paid-member-attention">
                退会される場合はその前に有料契約プランの停止をお願い致します。
            </div>
            <h3>有料会員プラン</h3>
            <div className="paid-status">契約中</div>
            <div className="next-payment-date">
                次回の自動更新日　
                {dayjs(props.paymentStatus.nextPaymentDate).format("YYYY/M/D")}
            </div>
            <p>
                有料会員プランの自動更新を停止すると、次回更新日まではこれまで通りご利用いただけますが、更新日以降はお相手とのメッセージや、コンシェルジュの相談・サポートがご利用いただけなくなります。
            </p>
            <LinkButton
                to={
                    props.paymentStatus.primaryPaymentMethod ===
                    IAPPaymentMethod.IOS_IAP
                        ? URL_PATHS.cancelSubscriptionProcedure()
                        : URL_PATHS.paymentCancel()
                }
                color="primary"
            >
                有料会員プランを停止する
            </LinkButton>
        </>
    );

interface ViewPaidStopMemberProps {
    paidStopMember: boolean;
    paymentStatus: aa.PaymentStatusObj;
}

const ViewPaidStopMember = (props: ViewPaidStopMemberProps) =>
    props.paidStopMember && (
        <>
            <h3>有料会員プラン</h3>
            <p>
                有料会員プランになると、マッチングしたお相手とのコンタクトやメッセージのやりとりが可能になります。
            </p>
            <LinkButton
                to={
                    props.paymentStatus.primaryPaymentMethod ===
                    IAPPaymentMethod.IOS_IAP
                        ? URL_PATHS.cancelSubscriptionProcedure()
                        : URL_PATHS.paymentRestartConfirm()
                }
                color="primary"
            >
                有料会員プランを継続する
            </LinkButton>
        </>
    );

export default ContractPaidMember;
